import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "middle" }
const _hoisted_2 = { class: "technical-support-group" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-8" }
const _hoisted_6 = { class: "description-tarif description-tarif-padding" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h6", null, "Troubleshooting", -1)
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "col-lg-4" }
const _hoisted_11 = {
  key: 0,
  class: "thank-you"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "68",
    height: "68",
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "34",
      cy: "34",
      r: "32.5",
      stroke: "#552DEB",
      "stroke-width": "3"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M25 32.8947L32.7 41L46 27",
      stroke: "#552DEB",
      "stroke-width": "3",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h5", null, "Thank you", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, " We have received your message. We will get back to you as soon as possible. ", -1)
const _hoisted_15 = {
  key: 1,
  class: "form-support"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h6", null, "Contact our support team", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, " Contact us on WhatsApp for quick, efficient support and reliable communication. ", -1)
const _hoisted_18 = ["href"]
const _hoisted_19 = {
  key: 1,
  class: "whatsapp-qr",
  src: "https://toosim.com/images/support/toosim_whatsapp_qr.png",
  alt: ""
}
const _hoisted_20 = { key: 2 }
const _hoisted_21 = { class: "input-group" }
const _hoisted_22 = { class: "input-group" }
const _hoisted_23 = { class: "input-group" }
const _hoisted_24 = ["disabled"]

import { useDataStore } from "@/stores/data";
import { computed, ComputedRef, nextTick, ref, Ref } from "vue";
import { checkEmailIsValid, detectMobile } from "@/helpers";
import MainLoader from "@/components/MainLoader.vue";
import { useUserStore } from "@/stores/user";
import WhatsappIcon from "@/components/icons/WhatsappIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SupportView',
  setup(__props) {

const dataStore = useDataStore();
const userStore = useUserStore();

const isMobile = detectMobile();
const email: Ref<string> = ref("");
const firstName: Ref<string> = ref("");
const question: Ref<string> = ref("");
const questionLoading: Ref<boolean> = ref(false);
const questionSent: Ref<boolean> = ref(false);
const showEmailForm: Ref<boolean> = ref(false);
const emailFormRef = ref();

async function sendSupport() {
  questionLoading.value = true;
  await dataStore.sendSupport(firstName.value, email.value, question.value);
  questionSent.value = true;
  firstName.value = "";
  email.value = "";
  question.value = "";
  questionLoading.value = false;
}

const formDisabled: ComputedRef<boolean> = computed(
  () =>
    !checkEmailIsValid(email.value) ||
    !firstName.value.length ||
    question.value.trim().length < 10 ||
    questionLoading.value
);

async function openEmailForm() {
  showEmailForm.value = true;
  await nextTick();

  document.documentElement.scrollTo({
    behavior: "smooth",
    top:
      emailFormRef.value.getBoundingClientRect().top +
      document.documentElement.scrollTop -
      emailFormRef.value.clientHeight,
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataStore).faqItems, (faqItem, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "technical-link"
                }, [
                  _createElementVNode("p", {
                    class: _normalizeClass({ open: faqItem.opened }),
                    onClick: ($event: any) => (faqItem.opened = !faqItem.opened)
                  }, _toDisplayString(faqItem.question), 11, _hoisted_8),
                  _createElementVNode("div", {
                    class: "technical-support-info",
                    style: _normalizeStyle(`display: ${faqItem.opened ? 'block' : 'none'};`),
                    innerHTML: faqItem.answer
                  }, null, 12, _hoisted_9)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            (questionSent.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _hoisted_12,
                  _hoisted_13,
                  _hoisted_14,
                  _createElementVNode("i", {
                    class: "off-you",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (questionSent.value = false))
                  })
                ]))
              : (_unref(userStore).isAuth)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _hoisted_16,
                    _hoisted_17,
                    (_unref(dataStore).whatsappLink)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          class: "whatsapp-button",
                          href: _unref(dataStore).whatsappLink,
                          target: "_blank"
                        }, [
                          _createVNode(WhatsappIcon, { class: "whatsapp-button__icon" }),
                          _createTextVNode(" Chat on WhatsApp ")
                        ], 8, _hoisted_18))
                      : _createCommentVNode("", true),
                    (!_unref(isMobile))
                      ? (_openBlock(), _createElementBlock("img", _hoisted_19))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: "button-link text-decoration-underline mb-3",
                      onClick: openEmailForm
                    }, " Get support by email "),
                    (showEmailForm.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_20, " Email us for support. Please note, replies may sometimes land in your spam folder "))
                      : _createCommentVNode("", true),
                    (showEmailForm.value)
                      ? (_openBlock(), _createElementBlock("form", {
                          key: 3,
                          onSubmit: _withModifiers(sendSupport, ["prevent"]),
                          ref_key: "emailFormRef",
                          ref: emailFormRef
                        }, [
                          _createElementVNode("div", _hoisted_21, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control",
                              placeholder: "Name",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((firstName).value = $event))
                            }, null, 512), [
                              [_vModelText, firstName.value]
                            ]),
                            _createElementVNode("i", {
                              class: "off-txt",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (firstName.value = ''))
                            })
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _withDirectives(_createElementVNode("input", {
                              type: "email",
                              class: "form-control",
                              placeholder: "Email",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((email).value = $event))
                            }, null, 512), [
                              [_vModelText, email.value]
                            ]),
                            _createElementVNode("i", {
                              class: "off-txt",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (email.value = ''))
                            })
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _withDirectives(_createElementVNode("textarea", {
                              class: "form-control",
                              placeholder: "Message",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((question).value = $event))
                            }, null, 512), [
                              [_vModelText, question.value]
                            ])
                          ]),
                          _createElementVNode("button", {
                            class: "btn btn-b btn-danger",
                            type: "submit",
                            disabled: formDisabled.value
                          }, [
                            _createTextVNode(" Send a question "),
                            (questionLoading.value)
                              ? (_openBlock(), _createBlock(MainLoader, { key: 0 }))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_24)
                        ], 544))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}
}

})